<script lang="ts">
    import {Accordion, AccordionItem, Button, Input, Label, MultiSelect, TabItem, Tabs} from 'flowbite-svelte';
    import sideMenuItems from "$lib/utils/sideMenuItems";
    import {onMount} from "svelte";
    import Typeahead from "$lib/components/Typeahead.svelte";
    import {get, post, retire} from "$lib/api";
    import {TrashBinOutline} from "flowbite-svelte-icons";
    import {invalidateAll} from "$app/navigation";
    import {allUnits} from "$lib/stores/unit";
    import {getUnits} from "$lib/calls/unit";

    export let data: { roles: any[] } = [];

    let selected: string[] = [];


    const addUserToRole = async (item) => {
        if(!item){
            return
        }
        await post(`/user/role/${item.roleId}/${item.userId}`)
        await invalidateAll()
    }
    const removeUserFromRole = async (item) => {
        await retire(`/user/role/${item.permissionRoleId}/${item.userId}`)
        await invalidateAll()
    }
    onMount(async() => {
        if($allUnits.length === 0) {
            $allUnits = await getUnits()
        }
    })
</script>
<Tabs>
    <TabItem title="Roles" open>
        <Accordion>
            {#if data.roles}
                {#each data.roles as item}
                    <AccordionItem>
                        {@const menu = JSON.parse(item.menuJson)}
                        <span slot="header">{item.name}</span>
                        <div class="grid gap-3 grid-cols-3">
                            <div>
                                <h3 class="text-lg">Accessible menu</h3>
                                <ul class="list-disc ml-3">
                                    {#each menu as item}
                                        <li>{sideMenuItems.find(x => x.href === item)?.label}</li>
                                    {/each}
                                </ul>
                            </div>
                            <div>
                                <Typeahead data={data.associates} let:item extract={ev => addUserToRole({...ev, roleId: item.id})}>
                                    {item.name} ({item.position} | {item.email})
                                </Typeahead>
                                {#await get('/user/role/' + item.id) then userRole}
                                    {#each userRole as role}
                                        <div class="flex gap-3 justify-between my-2 border rounded p-2 items-center">
                                            <p>
                                                {data.associates.find(x => x.userId === role.userId)?.name}
                                                <span class="text-sm leading-3">{data.associates.find(x => x.userId === role.userId)?.email}</span>
                                            </p>
                                            <Button color="red" pill class="!p-2" on:click={() => removeUserFromRole(userRole)}>
                                                <TrashBinOutline/>
                                            </Button>
                                        </div>

                                    {/each}
                                {/await}
                            </div>

                        </div>
                    </AccordionItem>
                {/each}
            {/if}
            <AccordionItem>
                <span slot="header">Neue Rolle</span>
                <form name="role-form" action="?/create_role" method="post">
                    <Label class="space-y-2">
                        <span>Name</span>
                        <Input type="text" name="name"/>
                    </Label>
                    <div class="mt-3">
                        <MultiSelect dropdownClass="bg-white" items={sideMenuItems.map(x => ({value:x.href, name:x.label}))} bind:value={selected} />
                        <input type="hidden" name="menuJson" value={selected}>
                    </div>

                    <div class="mt-3">
                        <Button type="submit">Anlegen</Button>
                    </div>

                </form>
            </AccordionItem>
        </Accordion>
    </TabItem>
    <TabItem title="Unit">
        <Accordion>
            {#each $allUnits as unit}
                <AccordionItem>
                    <span slot="header">{unit.name}</span>
                    {@const associatesByUnits = data.associates.filter(x => x.unitId === unit.id)}
                </AccordionItem>
            {/each}
        </Accordion>
    </TabItem>
</Tabs>

